import React, { useState, useEffect } from 'react';
import axios from 'axios';
import ReactPaginate from 'react-paginate';
import { Link } from 'react-router-dom';

import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { BASE_URL } from './config';

const UserList = () => {
  const [users, setUsers] = useState([]);
  const [pageCount, setPageCount] = useState(0);
  const [currentPage, setCurrentPage] = useState(0);

  useEffect(() => {
    fetchUsers(currentPage);
  }, [currentPage]);

  const fetchUsers = async (selectedPage) => {
    try {
      const response = await axios.get(`${BASE_URL}/v1/user/list`, {
        params: {
          page: selectedPage,
          size: 10, // Numero di utenti per pagina
        },
      });
      setUsers(response.data.content);
      setPageCount(response.data.totalPages);
    } catch (error) {
      toast.error('Errore durante il recupero degli utenti');
    }
  };

  const handlePageClick = (data) => {
    setCurrentPage(data.selected);
  };

  const handleToggleActive = async (userId, isActive) => {
    try {
      await axios.put(`${BASE_URL}/v1/user/${userId}/status`, { active: !isActive });
      fetchUsers(currentPage);
      toast.success('Utente ' + (!isActive ? 'attivato' : 'disattivato') + ' con successo');
    } catch (error) {
      toast.error('Errore durante la modifica dello stato utente');
    }
  };

  const handleDeleteUser = async (userId) => {
    const confirmDelete = window.confirm('Sei sicuro di voler cancellare questo utente?');
    if (confirmDelete) {
      try {
        await axios.delete(`${BASE_URL}/v1/user/${userId}`);
        setUsers((prevUsers) => prevUsers.filter((user) => user.id !== userId));
        toast.success('Utente cancellato con successo');
      } catch (error) {
        toast.error('Errore durante la cancellazione dell\'utente');
      }
    }
  };
  return (
    <div>
      <h2>Lista Utenti</h2>
      <table>
        <thead>
          <tr>
            <th>Titolare</th>
            <th>Nome azienda</th>
            <th>Email</th>
            <th>Tipo Azienda</th>
            <th>Tipo utente</th>
            <th>Attivo</th>
            <th>Azioni</th>
          </tr>
        </thead>
        <tbody>
          {users.map((user) => (
            <tr key={user.id}>
              <td>{user.nome +' ' +  user.cognome}</td>
              <td>{user.nomeAzienda}</td>

              <td>{user.email}</td>
              <td>{user.tipologiaAzienda}</td>
              <td>{user.tipoUtente}</td>
              <td>
                <input
                  type="checkbox"
                  checked={user.active}
                  onChange={() => handleToggleActive(user.id, user.active)}
                />
              </td>
              <td>
              <div style={{ display: 'inline-block' }}>
    <Link to={`/user/${user.id}`}>Dettaglio</Link>      
  </div>
  <div style={{ display: 'inline-block', marginLeft: '10px' }}>
    <button onClick={() => handleDeleteUser(user.id)}>Cancella</button>
  </div>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
      <ReactPaginate
        previousLabel={'Precedente'}
        nextLabel={'Successivo'}
        breakLabel={'...'}
        pageCount={pageCount}
        marginPagesDisplayed={2}
        pageRangeDisplayed={5}
        onPageChange={handlePageClick}
        containerClassName={'pagination'}
        activeClassName={'active'}
      />
      <ToastContainer />
    </div>
    
  );
};

export default UserList;
